import { ReactNode } from 'react';
import { Container } from '@qga/roo-ui/components';
import * as track from 'lib/gaTracking/cancelBookingPageEvents';
import { getBookingDetailsPageLink } from 'lib/links';
import { useDetailsBooking } from 'lib/hooks';
import PageHeader from 'components/PageHeader';
import { CreditVoucherDisclaimer, GlobalDisclaimers } from 'components/Disclaimers';

const CancellationPageLayout = ({ children }: { children: ReactNode }) => {
  const { booking } = useDetailsBooking();
  const detailsPageLink = getBookingDetailsPageLink(booking.id);

  return (
    <>
      <PageHeader
        title="Cancel your booking"
        bookingRef={booking.reference}
        showCloseSessionButton={!booking.account}
        backLinkUrl={detailsPageLink}
        backLinkTitle="Manage your booking"
        onClickBackLink={track.manageBookingReturnLinkTopSelected}
      />
      {children}
      <Container>
        <CreditVoucherDisclaimer.Body />
        <GlobalDisclaimers />
      </Container>
    </>
  );
};

export default CancellationPageLayout;
